import { useTranslations } from 'next-intl';
import { useAgentsList } from 'providers/AgentsProviders/useAgentsList';
import { Option } from 'types/Option';
import { useDebounce } from 'use-debounce';

interface IUseOptionsAgentsIn {
  query?: string;
  active?: boolean;
  sourceLanguageCode?: string;
}

interface IUseOptionsAgentsOut {
  optionsAgents: Option[];
}

export default function useOptionsAgents({
  query = '',
  active = false
}: IUseOptionsAgentsIn = {}): IUseOptionsAgentsOut {
  const t = useTranslations();
  const [deferredQuery] = useDebounce(query, 1000);

  const { data } = useAgentsList({
    query: deferredQuery,
    active
  });

  const optionsAgents = [
    {
      value: undefined,
      label: '',
      selected: false
    },
    ...(data?.nodes?.map((agent) => ({
      label: agent.name || '',
      value: agent.id
    })) ?? [])
  ];

  return { optionsAgents };
}
